<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Solicitações de marcações pendentes</div>
      </div>
      <div class="card-body">
        <div class="row" v-if="checkRequests.length && elementsReady">
          <div v-for="checkRequest in filtredElements" :key="checkRequest.id"
            class="col-md-6 offset-md-3 check-request-card" v-if="filtredElements">
            <div class="row mb-3">
              <div class="col-md-9">
                <h6>
                  <b>Colaborador: </b>
                  {{ checkRequest.user.name }}
                  {{ checkRequest.user.department_id }}

                </h6>
                <h6>
                  <b>Data e hora: </b>
                  {{ format(checkRequest.datetime) }}
                </h6>
                <h6>
                  <b> Justificativa Colaborador: </b>
                </h6>
                <p>{{ checkRequest.justification }}</p>
                <h6 v-if="checkRequest.downloadFile">
                  <a :href="checkRequest.downloadFile" target="_blank">Baixar Anexo</a>
                </h6>
                <div v-if="reprovingIds.includes(checkRequest.id)">
                  <h6>
                    <b> Justificativa Aprovador: </b>
                  </h6>
                  <textarea rows="5" class="form-control" v-model="checkRequest.approver_justification"></textarea>
                </div>
              </div>
              <div class="col-md-3">
                <div v-show="!reprovingIds.includes(checkRequest.id)">
                  <button class="btn btn-yes btn-block" :disabled="disabled" @click="approve(2, checkRequest)">
                    Aprovar
                  </button>
                  <button class="btn btn-no btn-block" :disabled="disabled" @click="justify(checkRequest)">
                    Reprovar
                  </button>
                </div>
                <div v-show="reprovingIds.includes(checkRequest.id)">
                  <button class="btn btn-yes btn-block" :disabled="disabled" @click="approve(3, checkRequest)">
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!checkRequests.length">
          <div class="col-md-6 offset-md-3">
            <div class="alert alert-primary" role="alert">
              Nenhuma solicitação pendente!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      checkRequests: [],
      reprovingIds: [],
      departments: [],
      filtredElements: [],
      disabled: false,
      elementsReady: false,
    };
  },
  methods: {
    justify(checkRequest) {
      const self = this;
      let index = self.reprovingIds.findIndex((x) => x == checkRequest.id);
      if (index !== -1) {
        self.reprovingIds.splice(index, 1);
      } else {
        self.reprovingIds.push(checkRequest.id);
      }
    },
    approve(status_id, checkRequest) {
      const self = this;
      self.disabled = true;
      const api = self.$store.state.api + "checkrequests/approve/";
      self.$http
        .post(api, {
          status_id: status_id,
          id: checkRequest.id,
          approver_justification: checkRequest.approver_justification,
        })
        .then((response) => {
          self.getData();
          self.$message("Sucesso", "Dados registrados com sucesso", "success");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    format(datetime) {
      return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
    },
    getData() {
      const self = this;
      const api = self.$store.state.api + "checkrequests?status_id=1&with[]=user&paginated=false";

      // Retorna uma promise para aguardar a conclusão da chamada assíncrona
      return new Promise((resolve, reject) => {
        self.$http
          .get(api)
          .then((response) => {
            self.checkRequests = response.data.data;
            self.disabled = false;
            resolve(); // Resolva a promise quando a chamada for bem-sucedida
          })
          .catch((error) => {
            self.message("Erro", error.response.data, "error");
            reject(error); // Rejeite a promise em caso de erro
          });
      });
    },

    getDepartments() {
      const self = this;
      const api = self.$store.state.api + "departments";

      // Retorna uma promise para aguardar a conclusão da chamada assíncrona
      return new Promise((resolve, reject) => {
        self.$http
          .get(api)
          .then((response) => {
            self.departments = response.data.data;
            resolve(); // Resolva a promise quando a chamada for bem-sucedida
          })
          .catch((error) => {
            self.message("Erro", error.response.data, "error");
            reject(error); // Rejeite a promise em caso de erro
          });
      });
    },

    checkUser() {
      const self = this;

      self.departments.forEach(department => {
        self.checkRequests.forEach(request => {

          if (department.id === request.user.department_id) {
            if (department.menager != '') {
              if (this.$store.state.user.id == department.menager) {

                self.filtredElements.push(request);
                self.elementsReady = true;

              }
            }


          }

        });
      });
    },
  },
  mounted() {

    const self = this;
    self.getData().then(() => {
      self.getDepartments().then(() => {
        self.checkUser();
      });
    });
  },
};
</script>

<style scoped>
.check-request-card {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background-color: white;
  padding-top: 10px;
}

/* .check-request-card:hover {
    } */
.btn-yes {
  border: 1px solid #2ea2cd;
  background-color: white;
  color: #2ea2cd;
}

.btn-yes:hover {
  border-radius: 1px solid white;
  background-color: #2ea2cd;
  color: white;
}

.btn-no {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);
}

.btn-no:hover {
  border-radius: 1px solid white;
  background-color: rgb(255, 70, 70);
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/CheckRequest/Approve.vue